module.exports = __webpack_public_path__ + "img/ucf1g-04.prt.3c4df421.jpg";